import { TurboColor } from '@/resources/enums/orders'
import {
  OrdersContext,
  OrdersAction,
  SetFeatureFlagActionValue,
} from '../types'
import { OrdersActions } from '../enums'

export const ordersDefault: OrdersContext = {
  featureFlags: {
    isHexaV2Enabled: false,
    turboColor: TurboColor.YELLOW,
    isEditOrderEnabled: false,
    isPickupCodeEnabled: false,
  },
}

const setFeatureFlag = (
  state: OrdersContext,
  { flag, value }: SetFeatureFlagActionValue
) => {
  return {
    ...state,
    featureFlags: { ...state.featureFlags, [flag]: value },
  }
}

export const ordersReducer = (state: OrdersContext, action: OrdersAction) => {
  switch (action.type) {
    case OrdersActions.SET_FEATURE_FLAG:
      return setFeatureFlag(state, action.value)
    default:
      return state
  }
}
